import Drawer from 'antd/lib/drawer';
import Typography from 'antd/lib/typography';
import * as React from 'react';
import { ReleaseStepType, TimelineEvent } from '../../types';
import { Timeline } from './TimelineEventsContainer';
import { UnorderedListOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { antGrey } from '../styles/globalStyles';
import Text from 'antd/lib/typography/Text';
import Divider from 'antd/lib/divider';
import { useDispatch } from 'react-redux';
import { updateTimelineEventsFilters } from '../../actions/filters';
import { Link } from 'react-router-dom';
import { createTimelineEventsRoute } from '../../helpers/routeHelpers';
import Button from 'antd/lib/button';
import { trackReleaseRouteEvent } from '@/actions/trackEvent';
import * as AnalyticEvents from '@/utils/analytics';

interface EventsTimelineDrawerProps {
    events: TimelineEvent[];
    orgId: string;
    appId: string;
    onClose: () => void;
    open: boolean;
    version: string;
    releaseStepDisplayName: string;
    releaseStepType?: ReleaseStepType;
    loadMore?: () => void;
    isLoading?: boolean;
    hasMore?: boolean;
}

export const EventsTimelineDrawer: React.FC<EventsTimelineDrawerProps> = React.memo(
    ({
        events,
        open,
        appId,
        orgId,
        onClose,
        version,
        releaseStepDisplayName,
        releaseStepType,
        loadMore,
        isLoading,
        hasMore,
    }) => {
        const dispatch = useDispatch();

        React.useEffect(() => {
            dispatch(
                trackReleaseRouteEvent({
                    orgId: orgId,
                    appId: appId,
                    releaseId: version,
                    eventName: AnalyticEvents.Event.ViewStepTimeline,
                }),
            );
        }, []);

        const renderTitle = () => {
            return (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%',
                    }}
                >
                    <div>
                        <UnorderedListOutlined style={{ marginRight: 5, color: antGrey.grey7, fontSize: '13px' }} />
                        <Text
                            style={{
                                fontSize: '13px',
                                color: antGrey.grey7,
                                letterSpacing: '0.1em',
                                textTransform: 'uppercase',
                                fontWeight: 400,
                                marginLeft: 8,
                            }}
                        >
                            Step timeline
                        </Text>
                        <Divider type="vertical" style={{ color: antGrey.grey5 }} />
                        <Typography.Text style={{ color: antGrey.grey9 }}>{releaseStepDisplayName}</Typography.Text>
                    </div>
                    <Link
                        to={{
                            pathname: createTimelineEventsRoute(orgId, appId, version),
                        }}
                    >
                        <Button type="link" style={{ margin: 0, paddingLeft: 0 }}>
                            View full timeline <ArrowRightOutlined />
                        </Button>
                    </Link>
                </div>
            );
        };

        return (
            <Drawer
                title={renderTitle()}
                placement="right"
                closeIcon={null}
                onClose={onClose}
                open={open}
                width={1000}
                bodyStyle={{ paddingTop: 8 }}
                afterOpenChange={() => dispatch(updateTimelineEventsFilters({ filters: [] }))}
            >
                <div style={{ marginTop: 12 }}>
                    <Timeline
                        events={events}
                        releaseId={version}
                        appId={appId}
                        orgId={orgId}
                        releaseStepType={releaseStepType}
                        isDrawerOpen={true}
                        hasMore={hasMore}
                        isLoading={isLoading}
                        loadMore={loadMore}
                    />
                </div>
            </Drawer>
        );
    },
);
